// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2SrU_","noInteraction":"EventWrapper_noInteraction__1A_Qg","pointerPassthrough":"EventWrapper_pointerPassthrough__1PEf-"};